export const cartData = [
    {
        id: '1',
        price: 30000,
        currency: 'IDR',
        name: 'Membership Registration',
        description: 'Pororo Park',
        quantity: 3,
        imageUrl: 'https://images.unsplash.com/photo-1584917865442-de89df76afd3?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=870&q=80',
    },
];
